var _circle, _path, _circle2, _path2, _g, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeUnsavedCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#E3FB94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 18.777h4.886l.9 3.84m0 0l2.94 12.567h17.106l3.142-12.567H12.984z",
    stroke: "#000",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.276,
    cy: 19.477,
    r: 9.076,
    fill: "#E3FB94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--unsaved-cart_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 11,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M28 11.199h16.664v16.664H28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--unsaved-cart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.332 23.005a.672.672 0 00.495-.2.672.672 0 00.2-.494.672.672 0 00-.2-.495.672.672 0 00-.495-.2.672.672 0 00-.495.2.672.672 0 00-.2.495c0 .196.067.361.2.494s.298.2.495.2zm0-2.777a.671.671 0 00.495-.2.672.672 0 00.2-.495v-2.777a.672.672 0 00-.2-.495.672.672 0 00-.495-.2.672.672 0 00-.495.2.672.672 0 00-.2.495v2.777c0 .197.067.362.2.495s.298.2.495.2zm0 6.249c-.96 0-1.863-.183-2.708-.547a7.013 7.013 0 01-2.204-1.484 7.01 7.01 0 01-1.485-2.205 6.76 6.76 0 01-.546-2.708c0-.96.182-1.863.547-2.708a7.01 7.01 0 011.484-2.204 7.013 7.013 0 012.204-1.484 6.762 6.762 0 012.708-.547c.96 0 1.863.182 2.708.547.845.364 1.58.859 2.205 1.484a7.01 7.01 0 011.484 2.204c.364.845.546 1.748.546 2.708 0 .96-.182 1.863-.546 2.708a7.01 7.01 0 01-1.484 2.205 7.013 7.013 0 01-2.205 1.484 6.761 6.761 0 01-2.708.547zm0-1.39c1.55 0 2.864-.537 3.94-1.613 1.077-1.077 1.615-2.39 1.615-3.94 0-1.551-.538-2.865-1.615-3.941-1.076-1.076-2.39-1.614-3.94-1.614-1.55 0-2.864.538-3.94 1.614-1.077 1.076-1.615 2.39-1.615 3.94 0 1.55.538 2.864 1.615 3.94 1.076 1.077 2.39 1.615 3.94 1.615z",
    fill: "#1C1B1F"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6,
    cy: 39.6,
    r: 2,
    fill: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.199,
    cy: 39.6,
    r: 2,
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--unsaved-cart-642db177ef25fae4e7bce5d5941bc93a.svg";
export { SvgIconCircleLimeUnsavedCart as Component };